import { type IDealType } from '@inpart-io/padme-iap';

import { i18nService } from '@/services/i18n-service';

export const LeadDealType: IDealType = {
    dobjId: 1,
    name: i18nService.t('NO_DEAL_TYPE').toString()
};
